import type { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { ReferralReward, ReferralRewardCreate, TableDataParams } from '@core/referrals-types';

const idSelector = ({ id }: { id: number | string }) => id;
const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralReward>()(
  'ReferralsRewardCollection',
  {
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);

      return {
        fetchPaginatedCollection: (state, payload: { params?: TableDataParams }) =>
          adapter.markAsPending(state),
        createOnePessimistic: (
          state,
          payload: { data: ReferralRewardCreate; correlationId: string },
        ) => defaultActions.createOnePessimistic(state, payload),
        updateOnePessimistic: (state, payload: { data: ReferralRewardCreate; id: number }) =>
          defaultActions.updateOnePessimistic(state, { data: { id: payload.id } }),
        deleteMany: (state, payload: { ids: number[] }) =>
          adapter.markAsPending(state, { entities: payload.ids, scope: null }),
        deleteManySuccess: (state, payload: { ids: number[] }) =>
          adapter.removeMany(state, payload.ids),
        deleteManyFailed: (state, payload: { error: HttpErrorResponse; data: { ids: number[] } }) =>
          adapter.setError(state, payload.error),
      };
    },
  },
);

export {
  actions as ReferralsRewardActions,
  reducer as ReferralsRewardReducer,
  selectors as ReferralsRewardSelectors,
  namespace as ReferralsRewardNamespace,
};
